module.exports = __webpack_public_path__ + "4f7e5f0c527023db7490310e9e964cd1.MP3";